<mat-card class="login-card">
  <div class="card-content">
    <div class="card-header">
      <h2>Olá, verificamos que você não possui nenhum carnê {{brandName}}.</h2>
      <h3>Mas pode ser que deseje falar com outras áreas:</h3>
    </div>

    <div class="actions">
      <button type="button" *ngIf="isCasasBahia" (click)="enviarLogAcaoCliente(LogAcaoCliente.COMPRA_CARNE)" mat-stroked-button class="outlined" color="primary">
        <img [src]="assets.installmentIcon" alt="carnê digital">
        Comprar com carnê
      </button>
      <button (click)="enviarLogAcaoCliente(LogAcaoCliente.CENTRAL_ATENDIMENTO)" mat-stroked-button class="outlined"
        color="primary">
        <mat-icon class="material-symbols-outlined">headset_mic</mat-icon>
        Central de atendimento
      </button>
      <button
        (click)="enviarLogAcaoCliente(isCasasBahia ? LogAcaoCliente.CARTAO_CASAS_BAHIA : LogAcaoCliente.CARTAO_PONTO)"
        mat-stroked-button class="outlined" color="primary">
        <img [src]="assets.creditCard" alt="cartão de credito">
        Cartão {{brandNameBtn}}
      </button>
      <button (click)="voltar.emit()" mat-flat-button color="primary">
        <mat-icon class="material-symbols-outlined">undo</mat-icon>
        Voltar
      </button>
    </div>

  </div>
</mat-card>